<template>
    <div>
        <div class="box view-nav-bar">
            <div class="d-flex align-items-center w-100">
                <span class="text-muted">
                    Last <strong>{{ bucket.limit || 30 }}</strong> Cinedata source files in <code>{{ bucket.folder }}</code>
                    <span v-if="rows.length">
                        — <strong :class="bucket.corrected_late ? 'text-warning' : ''">{{ bucket.corrected_late }}</strong>
                        of {{ rows.length }} still changed more than {{ bucket.window_days }} days after their play date
                    </span>
                </span>
            </div>
        </div>

        <div v-if="loading" class="box">
            <div class="box-content text-center text-muted py-4">Loading…</div>
        </div>

        <div v-else-if="!rows.length" class="box">
            <div class="box-content text-center text-muted py-4">No source files found.</div>
        </div>

        <div v-else class="box">
            <div class="box-content">
                <table class="shx-table w-100 mt-2">
                    <thead>
                        <tr>
                            <th>File</th>
                            <th class="shx-th-100">Play date</th>
                            <th class="text-right shx-th-80">Lines</th>
                            <th class="text-right shx-th-80">Size</th>
                            <th class="text-right shx-th-80">Revisions</th>
                            <th class="shx-th-140">First seen</th>
                            <th class="shx-th-140">Last changed</th>
                            <th class="text-right shx-th-100">Days after</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rows" :key="row.file">
                            <td>
                                <router-link v-if="bucket.git" :to="'/admissions/sources/' + row.file"><code>{{ row.file }}</code></router-link>
                                <code v-else>{{ row.file }}</code>
                            </td>
                            <td>
                                <router-link :to="'/admissions/day?from=' + row.day + '&to=' + row.day">{{ row.day }}</router-link>
                            </td>
                            <td class="text-right">{{ formatInt(row.lines) }}</td>
                            <td class="text-right">{{ formatSize(row.size) }}</td>
                            <td class="text-right">{{ row.revisions !== null ? row.revisions : '—' }}</td>
                            <td>{{ formatDate(row.first_changed) }}</td>
                            <td>{{ formatDate(row.last_changed) }}</td>
                            <td class="text-right">
                                {{ row.days_after }}
                                <span v-if="row.days_after > bucket.window_days"
                                      class="badge badge-warning ml-1"
                                      :title="'Still corrected ' + row.days_after + ' days after the play date'">⚠</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p class="text-muted small mt-2 mb-0">
                    One CSV per play date, straight from the
                    <a href="https://bitbucket.org/brightfishbe/cinedata_raw/" target="_blank" rel="noopener">cinedata_raw</a>
                    repository (line count includes the header row).
                    <template v-if="bucket.git">
                        Click a file to compare two of its revisions row by row.
                        <strong>Revisions</strong> is the number of commits that touched the file,
                        <strong>Days after</strong> the number of days between the play date and the last commit:
                        a high value means Cinedata was still correcting that day's admissions long after the fact.
                        ⚠ marks files changed more than {{ bucket.window_days }} days after their play date.
                    </template>
                    <template v-else>
                        The folder is not a git checkout, so dates are the file modification times.
                    </template>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AdmissionsSources',
    data() {
        return {
            loading: true,
            bucket: {},
            rows: [],
        };
    },
    created() {
        this.loadSources();
    },
    methods: {
        loadSources() {
            this.loading = true;
            axios
                .get('/admissions/sources')
                .then(response => {
                    this.bucket = response.data.data.bucket || {};
                    this.rows = response.data.data.rows || [];
                })
                .catch(error => {
                    this.$toast.error(error.response?.data?.error?.message || error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatInt(v) {
            return Math.round(v || 0).toLocaleString();
        },
        formatSize(bytes) {
            if (bytes >= 1024 * 1024) {
                return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
            }
            return Math.round(bytes / 1024) + ' kB';
        },
        formatDate(iso) {
            if (!iso) {
                return '—';
            }
            return iso.replace('T', ' ').substring(0, 16);
        },
    },
};
</script>
